module.exports = __webpack_public_path__ + "img/icon-31.3d393067.png";